import React from 'react'
import { Button } from 'semantic-ui-react'
import FormInput from 'components/forms/bases/FormInput'
import withTemporaryForm from 'hocs/bases/withTemporaryForm'
import { updateObject } from 'helpers/objectHelpers'

const FormSku = withTemporaryForm()(
  ({ value, onChange, onSubmit }) => (
    <div>
      <FormInput
        label="Product SKU"
        value={value}
        onChange={onChange}
      />
      <Button onClick={onSubmit}>OK</Button>
    </div>
  )
)

const ProductCardContent = ({
  value,
  value: {
    sku = '',
  },
  onChange,
}) => {
  const handleChange = (val, key) => {
    return onChange(updateObject(value, { [key]: val }))
  }
  return (
    <FormSku
      value={sku}
      onChange={(val) => handleChange(val, 'sku')}
    />
  )
}

ProductCardContent.propTypes = {}
ProductCardContent.defaultProps = {}

export default ProductCardContent



// WEBPACK FOOTER //
// ./src/components/Canvas/builder/elementForms/productCard/ProductCardContent.js